import React from "react";
import { SvgIcon } from "@mui/material";

const ManagementIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 87.733 96.222">
      <path
        id="Path_2148"
        data-name="Path 2148"
        d="M118.943,102.75h-9.56a1.209,1.209,0,1,0,0,2.418h9.56a4.69,4.69,0,0,1,4.685,4.685v41.3H40.73v-41.3a4.69,4.69,0,0,1,4.685-4.685h9.56a1.209,1.209,0,1,0,0-2.418h-9.56a7.111,7.111,0,0,0-7.1,7.1v47.894a7.111,7.111,0,0,0,7.1,7.1H69.7v14.475h-5.63a1.209,1.209,0,1,0,0,2.418h37.288a1.209,1.209,0,1,0,0-2.418h-6.69V164.85h24.28a7.111,7.111,0,0,0,7.1-7.1V109.853A7.111,7.111,0,0,0,118.943,102.75Zm-26.7,76.574H72.113V164.85H92.244Zm26.7-16.893H45.415a4.69,4.69,0,0,1-4.685-4.685v-4.171h82.9v4.171A4.69,4.69,0,0,1,118.943,162.432Z"
        transform="translate(-38.312 -85.521)"
      />
      <path
        id="Path_2149"
        data-name="Path 2149"
        d="M248.135,276.767a1.209,1.209,0,0,0-1.209,1.209v6.916a1.209,1.209,0,0,0,2.418,0v-6.916A1.209,1.209,0,0,0,248.135,276.767Z"
        transform="translate(-204.888 -224.471)"
      />
      <path
        id="Path_2150"
        data-name="Path 2150"
        d="M249.344,252.861a1.209,1.209,0,1,0-2.418,0v.789a1.209,1.209,0,0,0,2.418,0Z"
        transform="translate(-204.888 -204.417)"
      />
      <path
        id="Path_2151"
        data-name="Path 2151"
        d="M199.672,285.694a1.209,1.209,0,0,0-1.209,1.209V290a1.209,1.209,0,1,0,2.418,0v-3.1A1.209,1.209,0,0,0,199.672,285.694Z"
        transform="translate(-166.191 -231.599)"
      />
      <path
        id="Path_2152"
        data-name="Path 2152"
        d="M200.881,242.861a1.209,1.209,0,0,0-2.418,0v4.578a1.209,1.209,0,0,0,2.418,0Z"
        transform="translate(-166.191 -196.432)"
      />
      <path
        id="Path_2153"
        data-name="Path 2153"
        d="M296.6,276.369a1.209,1.209,0,0,0-1.209,1.209v7a1.209,1.209,0,0,0,2.418,0v-7A1.209,1.209,0,0,0,296.6,276.369Z"
        transform="translate(-243.586 -224.154)"
      />
      <path
        id="Path_2154"
        data-name="Path 2154"
        d="M297.808,242.861a1.209,1.209,0,0,0-2.418,0v2.764a1.209,1.209,0,0,0,2.418,0Z"
        transform="translate(-243.586 -196.432)"
      />
      <path
        id="Path_2155"
        data-name="Path 2155"
        d="M345.062,250.3a1.209,1.209,0,0,0-1.209,1.209v5.074a1.209,1.209,0,1,0,2.418,0v-5.074A1.209,1.209,0,0,0,345.062,250.3Z"
        transform="translate(-282.283 -203.338)"
      />
      <path
        id="Path_2156"
        data-name="Path 2156"
        d="M346.271,222.861a1.209,1.209,0,1,0-2.418,0v1.929a1.209,1.209,0,1,0,2.418,0Z"
        transform="translate(-282.283 -180.463)"
      />
      <path
        id="Path_2157"
        data-name="Path 2157"
        d="M151.209,258.085A1.209,1.209,0,0,0,150,259.294v4.635a1.209,1.209,0,1,0,2.418,0v-4.635A1.209,1.209,0,0,0,151.209,258.085Z"
        transform="translate(-127.494 -209.554)"
      />
      <path
        id="Path_2158"
        data-name="Path 2158"
        d="M152.418,222.861a1.209,1.209,0,1,0-2.418,0v2.98a1.209,1.209,0,1,0,2.418,0Z"
        transform="translate(-127.494 -180.463)"
      />
      <path
        id="Path_2159"
        data-name="Path 2159"
        d="M166.587,17.25H120.239A5.245,5.245,0,0,0,115,22.489V52.515a5.245,5.245,0,0,0,5.239,5.239h46.348a5.245,5.245,0,0,0,5.239-5.239V22.489A5.245,5.245,0,0,0,166.587,17.25Zm-46.348,2.418h46.348a2.824,2.824,0,0,1,2.821,2.821V47.283H136.783a4.474,4.474,0,0,0-8.613,0H117.418V22.489A2.824,2.824,0,0,1,120.239,19.668Zm14.293,28.824a2.055,2.055,0,1,1-2.055-2.055A2.055,2.055,0,0,1,134.532,48.492Zm32.055,6.843H120.239a2.824,2.824,0,0,1-2.821-2.821V49.7H128.17a4.474,4.474,0,0,0,8.613,0h32.625v2.813a2.824,2.824,0,0,1-2.821,2.821Z"
        transform="translate(-99.546 -17.25)"
      />
      <path
        id="Path_2160"
        data-name="Path 2160"
        d="M237.688,79.757a1.209,1.209,0,0,0,1.249-.077l5.223-3.612a1.209,1.209,0,0,0,0-1.989l-5.223-3.613a1.209,1.209,0,0,0-1.9.994v7.225A1.209,1.209,0,0,0,237.688,79.757Zm1.771-5.989,1.889,1.306-1.889,1.306Z"
        transform="translate(-196.995 -59.571)"
      />
      <path
        id="Path_2161"
        data-name="Path 2161"
        d="M211.314,64.808a9.914,9.914,0,1,0-9.914-9.914A9.914,9.914,0,0,0,211.314,64.808Zm0-17.411a7.5,7.5,0,1,1-7.5,7.5,7.5,7.5,0,0,1,7.5-7.5Z"
        transform="translate(-168.536 -39.391)"
      />
    </SvgIcon>
  );
};

export default ManagementIcon;
